<template>
    <div>
        <el-tooltip placement="top" :disabled="!item.disabled||loading||disabled" v-for="item in options" :key="item.name">
            <div slot="content">
                <span>{{item.popTip}}</span>
            </div>
            <div
                v-loading="loading"
                class="card-item inline-block pointer mr20"
                :class="[value==item.name?'active':'',item.disabled||disabled?'disabled':'']"
                @click="checkItem(item)"
            >
                <div class="title-text">{{item.title}}</div>
                <p class="desc-text">{{item.desc}}</p>
            </div>
        </el-tooltip>
    </div>

</template>

<script>
    export default {
        props:{
            options:Array,
            value:{
                type:String,
                default:'',
                require:true,
            },
            loading:Boolean,
            disabled:Boolean,
        },
        name: "SupplyCard",
        methods:{
            checkItem(item){
                if(item.disabled||this.loading||this.disabled) return false;
                this.$emit('change',item.name)
            },
        }
    }
</script>

<style lang="scss" scoped>
    .card-item{
        width: 200px;
        height: 150px;
        border: solid 1px #797979;
        font-size: 12px;
        vertical-align: middle;
        padding: 4px 10px;
        margin-bottom: 10px;

        .title-text{
            font-weight: bold;
        }
        .desc-text{
            line-height: 1.5;
            color: #aaa;
        }

        &.active{
            border: solid 2px #409EFF!important;
            .title-text{
                color: #409EFF!important;
            }
            .desc-text{
                color: #409EFF!important;
            }
        }


        &.disabled{
            background-color: #f2f2f2;
            border: solid 1px #ccc;
            cursor: not-allowed;
            .title-text{
                color: #999;
            }
            .desc-text{
                color: #aaa;
            }
        }
    }
</style>
